import React, { useEffect, useState } from 'react';
import {
  Col,
  Row,
  Modal,
  Input,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Container,
} from 'reactstrap';
import './index.css';
import { getAgeingReportApi, getCommitment, getCreditOutstandingBalanceApi, getStateDistrictCity, updateCreditLimit } from '../../../constants/apiCalls';
import { useLocation } from 'react-router-dom';
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';
import CreditLimit from '../../../Components/CreditLimit';
import PrimaryContact from '../../../Components/PrimaryContact';
import CropAcreage from '../../../Components/CropAcreage';
import Commitment from '../../../Components/Commitment';
import Competition from '../../../Components/Competition';
import AdvanceBusinessInfo from '../../../Components/AdvanceBusinessInfo/AdvanceBusinessInfo';
import BasicBusinessInformation from '../../../Components/BasicBusinessInformation/BasicBusinessInformation';
import ActiveOwner from '../../../Components/ActiveOwner/ActiveOwner';
import OtherOwners from '../../../Components/OtherOwners/OtherOwners';
import ApplicationApproval from '../../../Components/ApplicationApproval/ApplicationApproval';
import closeImg from '../../../images/close.png';
import ModalService from '../../../services/ModalService';
import { NumericFormat } from 'react-number-format';
import { Breadcrumbs } from '../../../Components/Breadcrumbs/Breadcrumbs';
import { BreadCrumbBackButton } from '../../../Components/Breadcrumbs/BreadCrumbBackButton';
import { CommonButton } from '../../../Components/CommonComponents';
import { Roles } from '../../../constants/Roles';
import Storage from '../../../services/Storage';
import { handleErrorMessage } from '../../../utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import { dealerInfoAction } from '../../../reducers/DealerReducer';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';

const ApproveApplicationSH = () => {

  const location = useLocation();
  let stringArr = location.pathname.split(/(\d+)/);
  let userId = stringArr[1];

  let userInfo = Storage.getUserInfoDetail();
  let roleName = userInfo ? userInfo.role : '';

  const [previewData, setPreviewData] = useState('');
  const [isMultipleUser, setIsMultipleUser] = useState(false);
  const [activeOwner, setActiveOwner] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [selectedOwnerState, setSelectedOwnerState] = useState('');
  const [selectedDistrict, setSelectedDistrict] = useState('');
  const [selectedOwnerDistrict, setSelectedOwnerDistrict] = useState('');
  const [selectedCity, setSelectedCity] = useState('');
  const [selectedOwnerCity, setSelectedOwnerCity] = useState('');
  const [isLoading, setIsloading] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);
  const [isShowDocuments, setIsShowDocuments] = useState(false);
  const [isShowCommitment, setIsShowCommitment] = useState(false);
  const [isShowEntireApp, setIsShowEntireApp] = useState(false);
  const [modal, setModal] = useState(false);
  const [creditLimitRemrks, setCreditLimitRemarks] = useState('');
  const [creditLimit, setCreditLimit] = useState('');
  const [isShowCompetition, setIsShowCompetition] = useState(false);
  const [commitments, setCommitments] = useState('');
  const [creditOutstandingBalance, setCreditOutstandingBalance] = useState('');
  const [ageingData, setAgeingData] = useState('');

  const dispatch = useDispatch();
  const { dealerObj } = useSelector(state => state.DealerReducer);

  useEffect(() => {
    if (userId) {
      getCommitments(userId);
      setIsloading(true);
      dispatch(dealerInfoAction(parseInt(userId), setIsloading));
    }
  }, []);

  useEffect(() => {
    setPreviewData(dealerObj);
    let filterActiveOwner = dealerObj && dealerObj.owners && dealerObj.owners.length > 0 ? dealerObj.owners.filter(val => val.is_primary_contact === true) : [];
    setActiveOwner(filterActiveOwner);
    getStatesData(
      dealerObj.pincode,
      dealerObj.state_id,
      dealerObj.district_id,
      dealerObj.city_id
    );
    if (dealerObj && dealerObj.owners && dealerObj.owners.length > 0) {
      getOwnerState(
        dealerObj.owners[0].pincode,
        dealerObj.owners[0].state_id,
        dealerObj.owners[0].district_id,
        dealerObj.owners[0].city_id
      );
    }
    if(dealerObj && dealerObj.dealer_code){
      getCreditOutstandingBalance();
      getAgeingReportData();
    }
  }, [dealerObj])

  useEffect(() => {
    if (isPrinting) {
      window.print();
      setIsPrinting(!isPrinting);
    }
  }, [isPrinting]);

  const getStatesData = (pincode, editStateId, editDistrictId, cityId) => {
    if (pincode) {
      let payload = {
        pincode: pincode,
      };
      getStateDistrictCity((res) => {
        const { success, data, error } = res;
        if (success === true) {
          if (data.length > 0) {
            let allData = data;
            // state array
            let stateArr = [
              ...new Map(allData.map((m) => [m.state_id, m])).values(),
            ]; // remove duplicate state
            setSelectedState(stateArr);

            // District array
            let districtArr = [
              ...new Map(allData.map((m) => [m.district_id, m])).values(),
            ]; // remove duplicate district
            let filterDistrict = districtArr.filter(
              (elem) => elem.district_id === editDistrictId
            );
            setSelectedDistrict(filterDistrict);

            // city Arr
            let cityArr = [
              ...new Map(allData.map((m) => [m.city_id, m])).values(),
            ]; // remove duplicate City
            let filterCity = cityArr.filter((elem) => elem.city_id === cityId);
            setSelectedCity(filterCity);

            setIsloading(false);
          }
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        }
        setIsloading(false);
      }, payload);
    }
  };

  // owner info
  const getOwnerState = (pincode, stateId, districtId, cityId) => {
    if (pincode) {
      let payload = {
        pincode: pincode,
      };
      getStateDistrictCity((res) => {
        const { success, data, error } = res;
        if (success === true) {
          if (data.length > 0) {
            let allData = data;
            // state array
            let stateArr = [
              ...new Map(allData.map((m) => [m.state_id, m])).values(),
            ]; // remove duplicate state
            setSelectedOwnerState(stateArr);

            // District array
            let districtArr = [
              ...new Map(allData.map((m) => [m.district_id, m])).values(),
            ]; // remove duplicate district
            let filterDistrict = districtArr.filter(
              (elem) => elem.district_id === districtId
            );
            setSelectedOwnerDistrict(filterDistrict);

            // city Arr
            let cityArr = [
              ...new Map(allData.map((m) => [m.city_id, m])).values(),
            ]; // remove duplicate City
            let filterCity = cityArr.filter((elem) => elem.city_id === cityId);
            setSelectedOwnerCity(filterCity);

            setIsloading(false);
          }
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        }
        setIsloading(false);
      }, payload);
    }
  };

  const toggle = (val) => {
    if (roleName === Roles.SH_NAME) {
      setCreditLimit(val.credit_limit);
    } else if (roleName === Roles.NH_NAME) {
      if (val.updated_credit_limit_remarks) {
        let limit =
          val.updated_credit_limit_remarks[
            val.updated_credit_limit_remarks.length - 1
          ].credit_limit;
        setCreditLimit(limit);
      } else {
        setCreditLimit(val.credit_limit);
      }
    }
    setModal(!modal);
  };

  const handleCreditLimit = (evt) => {
    evt.preventDefault();
    let editPayload = {
      dealer_id: userId,
      credit_limit: creditLimit,
      remark: creditLimitRemrks,
    };

    if (editPayload.dealer_id) {
      setIsloading(true);
      updateCreditLimit((res) => {
        const { success, message, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          setModal(!modal);
          dispatch(dealerInfoAction(parseInt(userId), setIsloading));
          setCreditLimit('');
          setCreditLimitRemarks('');
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
          setIsloading(false);
          setModal(!modal);
        }
        setIsloading(false);
      }, editPayload);
    }
  };

  const getCommitments = (id) => {
    if (id) {
      let payload = { user_id: id, page: 1, pagesize: 50, year: '' };
      getCommitment((res) => {
        const { success, data, error } = res;

        if (success === true) {
          for (let i = 0; i < data.length; i++) {
            setCommitments(data);
          }
        } else if (success === false || success === 'undefined') {
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        }
      }, payload);
    }
  };

  const getCreditOutstandingBalance = () => {
    let payload = { customer: dealerObj.dealer_code };
    getCreditOutstandingBalanceApi((res) => {
      const { success, data, error } = res;
      if (success === true) {
        const resData = data && data.length > 0 ? data[0] : '';
        setCreditOutstandingBalance(resData);
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    }, payload);
  };

  const getAgeingReportData = () => {
    let payload = { customer: dealerObj.dealer_code };
    getAgeingReportApi((res) => {
      const { success, data, error } = res;
      if (success === true) {
        const resData = data && data.length > 0 ? data[0] : '';
        setAgeingData(resData);
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    }, payload);
  };

  const handleOwner = (e, val) => {
    setIsMultipleUser(!isMultipleUser);
  };

  const handleDocuments = (e) => {
    setIsShowDocuments(!isShowDocuments);
    if (isShowCommitment) {
      setIsShowCommitment(!isShowCommitment);
    } else if (isShowCompetition) {
      setIsShowCompetition(!isShowCompetition);
    } else if (isShowEntireApp) {
      setIsShowEntireApp(!isShowEntireApp);
    }
  };

  const handleCommitment = (e) => {
    setIsShowCommitment(!isShowCommitment);
    if (isShowDocuments) {
      setIsShowDocuments(!isShowDocuments);
    } else if (isShowCompetition) {
      setIsShowCompetition(!isShowCompetition);
    } else if (isShowEntireApp) {
      setIsShowEntireApp(!isShowEntireApp);
    }
  };

  const handleCompetition = (e) => {
    setIsShowCompetition(!isShowCompetition);
    if (isShowDocuments) {
      setIsShowDocuments(!isShowDocuments);
    } else if (isShowCommitment) {
      setIsShowCommitment(!isShowCommitment);
    } else if (isShowEntireApp) {
      setIsShowEntireApp(!isShowEntireApp);
    }
  };

  const handleEnteireApp = (e) => {
    setIsShowEntireApp(!isShowEntireApp);
    if (isShowCommitment) {
      setIsShowCommitment(!isShowCommitment);
    } else if (isShowDocuments) {
      setIsShowDocuments(!isShowDocuments);
    } else if (isShowCompetition) {
      setIsShowCompetition(!isShowCompetition);
    }
  };

  return (
    <>
      <AppHeader />
      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id='ApproveApplicationSH'>
              {
                <Row className='noprint'>
                  <Col
                    xs={12}
                    className='d-flex flex-wrap align-items-center justify-content-between'
                  >
                    <Breadcrumbs title='Approve Application' />
                    <BreadCrumbBackButton />
                  </Col>
                </Row>
              }
              <CreditLimit
                toggle={() => toggle(previewData)}
                showButtons={true}
                previewData={previewData}
                handleCompetition={handleCompetition}
                handleDocuments={handleDocuments}
                handleCommitment={handleCommitment}
                handleEnteireApp={handleEnteireApp}
                isShowCompetition={isShowCompetition}
                isShowCommitment={isShowCommitment}
                isShowDocuments={isShowDocuments}
                isShowEntireApp={isShowEntireApp}
                creditOutstandingBalance={creditOutstandingBalance}
                ageingData={ageingData}
              />
              {isShowEntireApp && (
                <div>
                  <div id='businessInfoBlock'>
                    <BasicBusinessInformation
                      previewData={previewData}
                      activeOwner={activeOwner}
                      selectedCity={selectedCity}
                      selectedDistrict={selectedDistrict}
                      selectedState={selectedState}
                      userId={userId}
                    />
                  </div>
                  {/* crop acreages */}
                  <div id='cropAcreageBlock'>
                    <CropAcreage previewData={previewData} userId={userId} />
                  </div>
                  {/* advance business information */}
                  <div id='advanceInfoBlock'>
                    <AdvanceBusinessInfo previewData={previewData} userId={userId} />
                  </div>
                  <div id='commitmentBlock'>
                    <Commitment
                      previewData={commitments}
                      previewAllData={previewData}
                      userId={userId}
                    />
                  </div>
                  {/* Businesss Insights */}
                  <div id='bInsightBlock'>
                    <Competition previewData={previewData} userId={userId} />
                  </div>
                  <div id='ownerBlock'>
                    <ActiveOwner
                      activeOwner={activeOwner}
                      previewData={previewData}
                      isMultipleUser={isMultipleUser}
                      selectedOwnerCity={selectedOwnerCity}
                      selectedOwnerDistrict={selectedOwnerDistrict}
                      selectedOwnerState={selectedOwnerState}
                      handleOwner={handleOwner}
                      userId={userId}
                    />
                    <OtherOwners
                      previewData={previewData}
                      isMultipleUser={isMultipleUser}
                      selectedOwnerCity={selectedOwnerCity}
                      selectedOwnerDistrict={selectedOwnerDistrict}
                      selectedOwnerState={selectedOwnerState}
                      handleOwner={handleOwner}
                      userId={userId}
                    />
                  </div>
                  {/* Primary Contact Information */}
                  <div id='prContactBlock'>
                    <PrimaryContact previewData={previewData} userId={userId} />
                  </div>
                  {/* <ConfirmNote previewData={previewData} /> */}
                </div>
              )}
              {isShowCompetition && (
                <Competition userId={userId} previewData={previewData} />
              )}
              {isShowCommitment && (
                <Commitment
                  userId={userId}
                  previewData={commitments}
                  previewAllData={previewData}
                />
              )}
              {isShowDocuments && (
                <div id='advanceInfoBlock'>
                  <AdvanceBusinessInfo previewData={previewData} userId={userId} />
                </div>
              )}
              <div>
                <ApplicationApproval previewData={previewData} userId={userId} />
              </div>
              {/* {isShowEntireApp && <DealerSignStamp handlePrint={handlePrint} />} */}
              <Modal
                id='commitment-modal'
                isOpen={modal}
                toggle={toggle}
                className='modelCard'
                centered
              >
                <ModalBody className='pb-0'>
                  <div className='d-flex justify-content-end mb-2 closeModalBtn'>
                    <img src={closeImg} alt='closeIcon' onClick={() => setModal(!modal)} />
                  </div>
                  <Container>
                    <Form onSubmit={handleCreditLimit} id='form-reset'>
                      <Row>
                        <Col>
                          <FormGroup>
                            <Label className='common-input-label'>
                              Assign New Credit Limit
                            </Label>
                            <br />
                            <NumericFormat
                              type='text'
                              autoComplete='off'
                              name='detail'
                              thousandSeparator={true}
                              thousandsGroupStyle='lakh'
                              className='numberformat'
                              value={creditLimit}
                              onChange={(e) => setCreditLimit(e.target.value)}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              required
                              id='detail'
                              placeholder='Type here'
                            />
                          </FormGroup>
                          <FormGroup>
                            <Label className='common-input-label'>
                              Remarks for Credit Limit
                            </Label>
                            <br />
                            <Input
                              type='text'
                              autoComplete='off'
                              name='detail'
                              value={creditLimitRemrks}
                              onChange={(e) => setCreditLimitRemarks(e.target.value)}
                              required
                              id='detail'
                              placeholder='Type here'
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <div className='modalBtn d-flex align-items-center justify-content-center'>
                            <CommonButton name={'Submit'} btnClass={'btnPrimary'} type="submit" />
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </Container>
                </ModalBody>
              </Modal>
              {isLoading && <CustomSpinner />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ApproveApplicationSH;
